(function () {
  "use strict";

  var MOBILE_QUERY = "(max-width: 47.99em)";
  var bars = Array.prototype.slice.call(
    document.querySelectorAll("[data-mobile-sticky-cta]")
  );

  if (!bars.length || !window.matchMedia) return;
  var isMobile = window.matchMedia(MOBILE_QUERY).matches;

  function storageGet(type, key) {
    try {
      return window[type].getItem(key) || "";
    } catch (error) {
      return "";
    }
  }

  function storageSet(type, key, value) {
    try {
      window[type].setItem(key, value);
    } catch (error) {
      /* Storage can be unavailable in private browsing. The CTA still works. */
    }
  }

  function forcedVariant() {
    var match = /(?:^|[?&])sticky_cta=(control|variant)(?:&|$)/i.exec(
      window.location.search
    );
    return match ? match[1].toLowerCase() : "";
  }

  function assignedVariant(bar) {
    /* The requested 50/50 experiment is mobile-only; desktop always gets CTA. */
    if (!isMobile) return "variant";

    var experimentId = bar.getAttribute("data-experiment-id");
    if (!experimentId) return "variant";

    var forced = forcedVariant();
    if (forced) return forced;

    var key = "pn:mcta:experiment:" + experimentId;
    var stored = storageGet("localStorage", key);
    if (stored === "control" || stored === "variant") return stored;

    var share = parseFloat(bar.getAttribute("data-variant-share"));
    if (!isFinite(share)) share = 0.5;
    share = Math.max(0, Math.min(1, share));

    var variant = Math.random() < share ? "variant" : "control";
    storageSet("localStorage", key, variant);
    return variant;
  }

  function eventProps(bar, variant, extra) {
    var props = {
      page: bar.getAttribute("data-page") || window.location.pathname,
      product: bar.getAttribute("data-product") || "",
      placement: "sticky_product_cta",
      experiment_id: isMobile ? bar.getAttribute("data-experiment-id") || "" : "",
      variant: variant,
      mobile: isMobile,
      device: isMobile ? "mobile" : "desktop",
    };

    if (extra) {
      Object.keys(extra).forEach(function (key) {
        props[key] = extra[key];
      });
    }
    return props;
  }

  function emit(name, goalName, bar, variant, extra) {
    var props = eventProps(bar, variant, extra);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      mobile_sticky_page: props.page,
      mobile_sticky_product: props.product,
      mobile_sticky_placement: props.placement,
      mobile_sticky_experiment_id: props.experiment_id,
      mobile_sticky_variant: props.variant,
      mobile_sticky_device: props.device,
      mobile_sticky_destination: props.destination || "",
      mobile_sticky_product_index: props.product_index || 0,
      mobile_sticky_product_count: props.product_count || 0,
    });

    try {
      if (typeof window._zbw !== "function") {
        window._zbw = function () {
          (window._zbw.q = window._zbw.q || []).push(arguments);
        };
      }
      window._zbw("event", goalName, props);
    } catch (error) {
      /* Analytics must never block the outbound link. */
    }
  }

  function isAmazonLink(anchor) {
    try {
      var url = new URL(anchor.href, window.location.href);
      return /(^|\.)amazon\.[a-z.]+$|(^|\.)amzn\.(to|com)$/i.test(url.hostname);
    } catch (error) {
      return false;
    }
  }

  function makeAmazonLinksAppFriendly() {
    var anchors = Array.prototype.slice.call(document.querySelectorAll("a[href]"));
    anchors.forEach(function (anchor) {
      if (!isAmazonLink(anchor)) return;

      /*
       * A normal same-window HTTPS navigation gives Amazon's Universal/App Link
       * handoff the best chance to open the installed app. A forced new tab can
       * strand mobile visitors in an in-app browser instead.
       */
      anchor.removeAttribute("target");
      var rel = (anchor.getAttribute("rel") || "").split(/\s+/).filter(Boolean);
      if (rel.indexOf("sponsored") === -1) rel.push("sponsored");
      anchor.setAttribute("rel", rel.join(" "));
    });
  }

  function cleanText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function headingLevel(el) {
    var match = /^H([1-6])$/.exec(el.tagName);
    return match ? parseInt(match[1], 10) : 2;
  }

  function isHeading(el) {
    return el.tagName === "H2" || el.tagName === "H3";
  }

  function holdsCallout(el) {
    return (
      el.classList.contains("product-box-callout") ||
      !!el.querySelector(".product-box-callout")
    );
  }

  var taglineHeadings = [];

  /*
   * Where a product callout starts "its" stretch of the article. A callout
   * that opens a section (it sits right under the heading) takes over at that
   * heading; one further down takes over where it appears. Either way the
   * product stays up until the section it sits in ends, so the level is the
   * level of the heading above it.
   */
  function calloutAnchor(callout, article, productName) {
    var block = callout;
    while (block.parentElement && block.parentElement !== article) {
      block = block.parentElement;
    }

    var heading = null;
    var section = null;
    var steps = 0;
    var sawCallout = false;
    var previous = block.previousElementSibling;
    while (previous && !section) {
      if (isHeading(previous)) {
        if (!heading) heading = previous;
        if (previous.tagName === "H2") section = previous;
      } else if (!heading) {
        if (holdsCallout(previous)) sawCallout = true;
        steps++;
      }
      previous = previous.previousElementSibling;
    }

    /* A section named after the product ("Dolphin Liberty: The Cordless
       Option") is that product's from its heading on, wherever the callout
       sits inside it. */
    var name = cleanText(productName).toLowerCase();
    if (
      section &&
      name &&
      cleanText(section.textContent).toLowerCase().indexOf(name) !== -1
    ) {
      return { el: section, level: 2 };
    }

    var level = heading ? headingLevel(heading) : 2;
    if (heading && !sawCallout && steps <= 2) {
      /* Heading, callout, then a tagline heading of the same level ("1. Dolphin
         Premier" / callout / "The Ultimate in Customizable Filtration"): the
         tagline continues this product, it does not end its section. */
      var next = block.nextElementSibling;
      if (
        steps === 0 &&
        next &&
        isHeading(next) &&
        headingLevel(next) === level
      ) {
        taglineHeadings.push(next);
      }
      return { el: heading, level: level };
    }
    return { el: callout, level: level };
  }

  function staticProducts(bar) {
    var catalog = bar.querySelector("[data-mobile-sticky-products]");
    if (!catalog) return [];

    var products;
    try {
      products = JSON.parse(catalog.textContent || "[]");
    } catch (error) {
      return [];
    }
    if (!Array.isArray(products)) return [];

    var article = document.querySelector(".art-content");
    var callouts = article
      ? article.querySelectorAll(".product-box-callout")
      : [];

    products.forEach(function (product) {
      var anchors = [];
      function add(anchor) {
        var known = anchors.some(function (existing) {
          return existing.el === anchor.el;
        });
        if (!known) anchors.push(anchor);
      }

      var section = product.sectionId
        ? document.getElementById(product.sectionId)
        : null;
      if (section) add({ el: section, level: headingLevel(section) });

      (product.callouts || []).forEach(function (index) {
        if (callouts[index]) {
          add(calloutAnchor(callouts[index], article, product.name));
        }
      });

      product.anchors = anchors;
    });

    return products;
  }

  function setupProductChooser(bar, cta, variant) {
    var products = staticProducts(bar);
    if (!products.length) return null;

    var select = bar.querySelector("[data-mobile-sticky-select]");
    var name = bar.querySelector("[data-mobile-sticky-name]");
    var eyebrow = bar.querySelector("[data-mobile-sticky-eyebrow]");
    var imageWrap = bar.querySelector(".mobile-sticky-cta__image");
    var label = cta ? cta.querySelector("span") : null;
    if (!select || !name || !eyebrow || !imageWrap || !cta) return null;

    /*
     * The page's top pick is whatever the server rendered: the route-level
     * pick from mobileStickyCta.js, or the first product in the ranking chart.
     * Its wording, photo and link stay exactly as rendered, so a pinned pick
     * keeps its own eyebrow and retailer wherever it shows.
     */
    var initialName = cleanText(bar.getAttribute("data-product")).toLowerCase();
    var topIndex = 0;
    products.forEach(function (product, index) {
      if (product.name.toLowerCase() === initialName) topIndex = index;
    });
    var topImage = imageWrap.querySelector("img");
    var top = {
      eyebrow: cleanText(eyebrow.textContent),
      href: cta.getAttribute("href"),
      rel: cta.getAttribute("rel"),
      label: label ? label.textContent : "",
      src: topImage ? topImage.getAttribute("src") : "",
      srcset: topImage ? topImage.getAttribute("srcset") : "",
    };
    if (top.href) products[topIndex].buyUrl = top.href;

    var state = {
      products: products,
      currentIndex: topIndex,
      showProduct: null,
      showTopPick: null,
      showDeals: null,
      bar: bar,
      cta: cta,
    };

    function setImage(src, srcset) {
      if (!src) {
        imageWrap.hidden = true;
        return;
      }
      var image = imageWrap.querySelector("img");
      if (!image) {
        image = document.createElement("img");
        image.alt = "";
        image.width = 40;
        image.height = 40;
        image.decoding = "async";
        imageWrap.appendChild(image);
      }
      if (srcset) image.setAttribute("srcset", srcset);
      else image.removeAttribute("srcset");
      image.src = src;
      imageWrap.hidden = false;
    }

    function showPicker() {
      name.hidden = products.length > 1;
      select.hidden = products.length <= 1;
      if (label) label.textContent = top.label;
      if (top.rel) cta.setAttribute("rel", top.rel);
      cta.removeAttribute("data-deals-cta");
    }

    function showProduct(index, trackChange, asTopPick) {
      var product = products[index];
      if (!product) return;

      showPicker();
      bar.setAttribute("data-product", product.name);
      name.textContent = product.name;
      eyebrow.textContent = asTopPick
        ? top.eyebrow
        : product.category || "Featured pick";
      cta.href = product.buyUrl;
      cta.setAttribute("data-product", product.name);
      cta.setAttribute("aria-label", "Buy " + product.name);
      if (index === topIndex && top.src) setImage(top.src, top.srcset);
      else setImage(product.image, "");
      select.value = String(index);
      state.currentIndex = index;

      if (trackChange) {
        emit(
          "mobile_sticky_cta_product_change",
          "Mobile Sticky CTA Product Change",
          bar,
          variant,
          {
            destination: product.buyUrl,
            product_index: index + 1,
            product_count: products.length,
          }
        );
      }
    }

    /*
     * Past the final verdict there is no single product left to point at, so
     * the bar says what its button does: it opens the deals page.
     */
    function showDeals() {
      name.hidden = false;
      select.hidden = true;
      name.textContent = "Today's deals";
      bar.setAttribute("data-product", "Today's deals");
      cta.setAttribute("data-product", "Today's deals");
      eyebrow.textContent = "Every pick in this guide";
      imageWrap.hidden = true;
      if (label) label.textContent = "See deals";
      cta.href = "/deals";
      cta.removeAttribute("rel");
      cta.setAttribute("data-deals-cta", "sticky_product_cta_final_verdict");
      cta.setAttribute("aria-label", "See today's deals on every featured product");
    }

    if (products.length > 1) {
      select.addEventListener("change", function () {
        showProduct(parseInt(select.value, 10), true, false);
      });
    }
    state.showProduct = showProduct;
    state.showTopPick = function () {
      showProduct(topIndex, false, true);
    };
    state.showDeals = showDeals;
    state.showTopPick();
    return state;
  }

  /*
   * Keeps the bar on the product the reader is actually reading about.
   *
   * Every product knows where its coverage starts (its section heading and
   * any callout that features it). The product whose start was scrolled past
   * most recently wins, but only while the reader is still inside that
   * section: once a later heading of the same or a higher level goes by
   * (buying advice, FAQs, another lineup), the bar returns to the page's top
   * pick instead of hanging on to the last product it happened to show.
   */
  function syncProductToScroll(chooser) {
    if (!chooser || !chooser.products) return;

    var article = document.querySelector(".art-content");
    if (!article) return;

    var boundaries = Array.prototype.slice
      .call(article.children)
      .filter(function (el) {
        return isHeading(el) && taglineHeadings.indexOf(el) === -1;
      })
      .map(function (el) {
        return { el: el, level: headingLevel(el) };
      });
    var verdict =
      chooser.products.length > 1
        ? article.querySelector('h2[id$="final-verdict"]')
        : null;
    var ticking = false;
    var lastTarget = null;

    function update() {
      ticking = false;
      var triggerLine = Math.min(window.innerHeight * 0.35, 280);
      var target = -1;

      if (verdict && verdict.getBoundingClientRect().top <= triggerLine) {
        target = "deals";
      } else {
        var passed = [];
        boundaries.forEach(function (boundary) {
          /* A heading that is not rendered reports a top of 0, which would
             read as "just scrolled past" for the whole article. */
          if (!boundary.el.getClientRects().length) return;
          var top = boundary.el.getBoundingClientRect().top;
          if (top <= triggerLine) {
            passed.push({ el: boundary.el, level: boundary.level, top: top });
          }
        });

        var bestTop = -Infinity;
        chooser.products.forEach(function (product, index) {
          product.anchors.forEach(function (anchor) {
            if (!anchor.el.getClientRects().length) return;
            var top = anchor.el.getBoundingClientRect().top;
            if (top > triggerLine || top <= bestTop) return;
            var left = passed.some(function (heading) {
              return (
                heading.el !== anchor.el &&
                heading.top > top &&
                heading.level <= anchor.level
              );
            });
            if (left) return;
            target = index;
            bestTop = top;
          });
        });
      }

      /* Only act on a change, so a product picked by hand from the list stays
         up until the reader moves on to a different part of the article. */
      if (target === lastTarget) return;
      lastTarget = target;
      if (target === "deals") chooser.showDeals();
      else if (target === -1) chooser.showTopPick();
      else chooser.showProduct(target, false, false);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);
  }

  function alignToArticle(bar) {
    function update() {
      var article = document.querySelector(".art-content");
      if (!article || !window.matchMedia("(min-width: 64em)").matches) {
        bar.classList.remove("is-article-aligned");
        bar.style.removeProperty("--sticky-article-left");
        bar.style.removeProperty("--sticky-article-width");
        return;
      }

      var rect = article.getBoundingClientRect();
      bar.style.setProperty("--sticky-article-left", rect.left + "px");
      bar.style.setProperty("--sticky-article-width", rect.width + "px");
      bar.classList.add("is-article-aligned");
    }

    update();
    window.addEventListener("resize", update);
  }

  function stickyPointHasReached() {
    var toc = document.getElementById("art-toc");
    if (toc && window.matchMedia("(min-width: 64em)").matches) {
      var stickyTop = parseFloat(window.getComputedStyle(toc).top);
      if (!isFinite(stickyTop)) stickyTop = 0;
      return toc.getBoundingClientRect().top <= stickyTop + 1;
    }

    var article = document.querySelector(".art-content");
    if (!article) return true;
    var nav = document.getElementById("globalNav");
    var navBottom =
      nav && !nav.classList.contains("is-hidden")
        ? nav.getBoundingClientRect().bottom
        : 0;
    return article.getBoundingClientRect().top <= navBottom + 8;
  }

  function init(bar) {
    var variant = assignedVariant(bar);
    var experimentId = isMobile ? bar.getAttribute("data-experiment-id") : "";

    if (experimentId) {
      emit(
        "mobile_sticky_cta_exposure",
        "Mobile Sticky CTA Exposure",
        bar,
        variant
      );
    }
    if (variant === "control") return;

    var page = bar.getAttribute("data-page") || window.location.pathname;
    var dismissKey = "pn:mcta:dismissed:" + page;
    if (storageGet("sessionStorage", dismissKey) === "1") return;

    var cta = bar.querySelector(".mobile-sticky-cta__button");
    var dismiss = bar.querySelector("[data-mobile-sticky-dismiss]");
    var revealAfter = parseInt(bar.getAttribute("data-reveal-after"), 10);
    var revealed = false;
    var dismissedByUser = false;
    var lifecycleTicking = false;
    var lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (!isFinite(revealAfter) || revealAfter < 0) revealAfter = 0;

    alignToArticle(bar);
    var productChooser = setupProductChooser(bar, cta, variant);
    syncProductToScroll(productChooser);

    function setVisible(visible) {
      bar.classList.toggle("is-visible", visible);
      document.body.classList.toggle("mobile-sticky-cta-visible", visible);
    }

    function articleHasEnded() {
      var top = parseFloat(window.getComputedStyle(bar).top);
      if (!isFinite(top)) top = 0;
      var barBottom = top + bar.offsetHeight + 8;
      var endMarker = document.querySelector(".art-trust");
      if (endMarker) return endMarker.getBoundingClientRect().top <= barBottom;

      var main = document.getElementById("main");
      return main ? main.getBoundingClientRect().bottom <= barBottom : false;
    }

    function updateLifecycle() {
      if (!revealed || dismissedByUser) {
        lifecycleTicking = false;
        return;
      }
      setVisible(stickyPointHasReached() && !articleHasEnded());
      lifecycleTicking = false;
    }

    function requestLifecycleUpdate() {
      if (lifecycleTicking) return;
      lifecycleTicking = true;
      window.requestAnimationFrame(updateLifecycle);
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      bar.hidden = false;

      window.requestAnimationFrame(function () {
        setVisible(stickyPointHasReached() && !articleHasEnded());
      });

      window.addEventListener("scroll", requestLifecycleUpdate, { passive: true });
      window.addEventListener("resize", requestLifecycleUpdate);
      emit("mobile_sticky_cta_view", "Mobile Sticky CTA View", bar, variant);
    }

    function maybeReveal() {
      var currentScrollY =
        window.pageYOffset || document.documentElement.scrollTop || 0;
      var movingDown = currentScrollY > lastScrollY;
      lastScrollY = currentScrollY;
      if (
        !movingDown ||
        currentScrollY < revealAfter ||
        !stickyPointHasReached() ||
        articleHasEnded()
      ) {
        return;
      }

      window.removeEventListener("scroll", maybeReveal);
      reveal();
    }

    if (cta) {
      cta.addEventListener("click", function () {
        emit("mobile_sticky_cta_click", "Mobile Sticky CTA Click", bar, variant, {
          destination: cta.href,
        });
      });
    }

    if (dismiss) {
      dismiss.addEventListener("click", function () {
        dismissedByUser = true;
        storageSet("sessionStorage", dismissKey, "1");
        setVisible(false);
        window.removeEventListener("scroll", requestLifecycleUpdate);
        window.removeEventListener("resize", requestLifecycleUpdate);
        emit(
          "mobile_sticky_cta_dismiss",
          "Mobile Sticky CTA Dismiss",
          bar,
          variant
        );
        window.setTimeout(function () {
          bar.hidden = true;
        }, 450);
      });
    }

    window.addEventListener("scroll", maybeReveal, { passive: true });
  }

  if (isMobile) makeAmazonLinksAppFriendly();
  bars.forEach(init);
})();
